import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';

//login Page
import Login from './components/Login/Login';

//context Auth Provider
import { AuthProvider } from './context/auth';

//protected Routes
import { ProtectedRoute } from './ProtectedRoutes';

//mainLayout
import Layout from './components/Layout/Layout';

//Dashboard Screen start
import Dashboard from './components/Dashboard/Dashboard';
import PDFView, { ImageView } from './components/commoncomponents/PdfView';
import PageNotFound from './components/commoncomponents/PageNotFound';
import ThankYouPage from './components/commoncomponents/ThankYouPage';
//Dashboard Screen End


function App() {
    return (
        <>
            <ToastContainer position={'top-center'} />
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route exact path='/Dashboard' element={<Dashboard />} />
                            <Route exact path='/ThankYou' element={<ThankYouPage/>} />

                        </Route>
                        <Route exact path='/' element={<Login />} />
                        {/*<Route exact path='/forgotPassword' element={<ForgotPasswordSlide1 />} />*/}
                        <Route exact path='/PdfView' element={<PDFView />} />
                        <Route exact path='/ImageView' element={<ImageView />} />
                        <Route path='*' element={<PageNotFound />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </>
    );
}

export default App;
